export const SubscriptionEvents = {
   setRecaptchaParams: 'subscriptionEvents/setRecaptchaParams',
} as const;
